import { useEffect, useState } from 'react'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { pluralize } from '~/helpers/pluralize'
import { useCustomerListDetail } from '~/hooks'
import { convertToCartItem } from '~/sections/ListDetails'
import { CartItemCard } from '../CartItemCard'
import { LoadingSpinner } from '../LoadingSpinner'
import { ListItemProps } from './CustomerListsDrawerDrawer.types'

export const ProductList = ({ list }: ListItemProps) => {
  const [loading, setLoading] = useState(true)
  const {
    updateCustomerList,
    removeFromCustomerList,
    fetchCustomerListDetail,
    detail,
  } = useCustomerListDetail(list)

  useEffect(() => {
    if (list?.id) {
      fetchCustomerListDetail(list.id, setLoading)
    }
  }, [fetchCustomerListDetail, list.id])

  if (loading) {
    return (
      <div className='grid w-full h-full place-content-center'>
        <LoadingSpinner />
      </div>
    )
  }

  const updatedProductList = [
    ...new Set(
      (detail?.products || []).map((product) => {
        return JSON.stringify(product)
      })
    ),
  ].map((product) => {
    return JSON.parse(product)
  })

  return (
    <div>
      <Typography
        tag={TypographyTag.p}
        variant={TypographyVariant.Heading6}
        className='mb-6'>
        {pluralize(updatedProductList?.length, 'product')}
      </Typography>
      <div className='flex flex-col gap-y-8'>
        {updatedProductList?.map((product, index) => {
          const item = convertToCartItem(product)
          return (
            <div key={index} className='pb-6 border-b relative'>
              <CartItemCard
                item={item}
                isEditable
                isLoading={false}
                onChangeQuantity={(qty) => {
                  updateCustomerList(list.id, product.sku, qty)
                }}
                removeCartItem={() => {
                  removeFromCustomerList(list.id, [product.sku])
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
